/** @format */

import { createAction, props, Action } from '@ngrx/store';
import {
	DelegationEntry,
	ManagerEmployeeTimesheetView,
	NewUser,
	PayPeriod,
	PayPeriodEntry,
	PostTimesheet,
	ScheduledActingAssignment,
	TeamMemberProfile,
	TimeEntry,
	TimeentryDB,
	TimeentryDBByPeriod,
	Timesheet,
	TimesheetApprovalSubmission,
	UpdateMemberConfig,
	UpdateUserAccount,
	User,
	UserNotification,
	UserTimesheet,
} from './application.state';
import { Configuration, ManageProfile, Profile } from 'src/app/models/profile';
// import { Action } from 'rxjs/internal/scheduler/Action';
import { TimeBank } from 'src/app/models/timeBank';
import { EmailNotification } from 'src/app/models/notifications';
import { SafeUrl } from '@angular/platform-browser';
import { HttpErrorResponse } from '@angular/common/http';

// to define an Action, use the `createAction` method
export const AddSingleUser = createAction('[Application Module] AddSingleUser', props<{ newUser: NewUser }>());

export const GetAllPayPeriodData = createAction('[Application Module] GetAllPayPeriodData');

export const GetAllPayPeriodDataSuccess = createAction('[Application Module] GetAllPayPeriodDataSuccess', props<{ payPeriods: PayPeriod[] }>());

export const GetAllPayPeriodDataError = createAction('[Application Module] GetAllPayPeriodDataError', props<{ error: any }>());

export const AttemptApplicationStart = createAction('[Application Module] AttemptApplicationStart');

export const GetAllScheduledActingAssignments = createAction('[Application Module] GetAllScheduledActingAssignments');

export const GetAllScheduledActingAssignmentsSuccess = createAction(
	'[Application Module] GetAllScheduledActingAssignmentsSuccess',
	props<{ scheduledActingAssignments: ScheduledActingAssignment[] }>()
);

export const GetAllScheduledActingAssignmentsError = createAction(
	'[Application Module] GetAllScheduledActingAssignmentsError',
	props<{ error: any }>()
);

export const GetScheduledActingAssignments = createAction('[Application Module] GetScheduledActingAssignments');

export const GetScheduledActingAssignmentsSuccess = createAction(
	'[Application Module] GetScheduledActingAssignmentsSuccess',
	props<{ scheduledActingAssignments: ScheduledActingAssignment[] }>()
);

export const GetScheduledActingAssignmentsError = createAction('[Application Module] GetScheduledActingAssignmentsError', props<{ error: any }>());

export const GetUserRelatedActingAssignments = createAction('[Application Module] GetUserRelatedActingAssignments');

export const AddScheduledActingAssignment = createAction(
	'[Application Module] AddScheduledActingAssignment',
	props<{ scheduledActingAssignment: ScheduledActingAssignment }>()
);

export const UpdateScheduledActingAssignment = createAction(
	'[Application Module] UpdateScheduledActingAssignment',
	props<{ scheduledActingAssignment: ScheduledActingAssignment }>()
);

export const DeleteScheduledActingAssignment = createAction('[Application Module] DeleteScheduledActingAssignment', props<{ id: number }>());

export const StartApplication = createAction('[Application Module] StartApplication');

export const GenerateCalendarData = createAction('[Application Module] GenerateCalendarData', props<{ payPeriodEntries: PayPeriodEntry[] }>());

export const LoadNextYear = createAction('[Application Module] LoadNextYear');

export const LoadPreviousYear = createAction('[Application Module] LoadPreviousYear');

export const GetProfile = createAction('[Application Module] GetProfile', props<{ skipUserActivation?: boolean }>());

export const GetProfileSuccess = createAction('[Application Module] GetProfileSuccess', props<{ profile: Profile }>());

export const GetProfilePicture = createAction('[Application Module] GetProfilePicture');

export const SetProfilePicture = createAction('[Application Module] SetProfilePicture', props<{ pictureBlob: Blob | null }>());

export const GetAllUsers = createAction('[Application Module] GetAllUsers');

export const SetAllUsers = createAction('[Application Module] SetAllUsers', props<{ allUsers: User[] }>());

export const PruneManagedActiveUsers = createAction('[Application Module] PruneManagedActiveUsers', props<{ users: User[] }>());

export const PruneManagedActiveUsersSuccess = createAction('[Application Module] PruneManagedActiveUsersSuccess', props<{ users: User[] }>());

export const PruneManagedActiveUsersError = createAction('[Application Module] PruneManagedActiveUsersError', props<{ error: any }>());

export const SetUsersInactive = createAction('[Application Module] SetUsersInactive', props<{ userIds: number[] }>());

export const SetUsersInactiveSuccess = createAction('[Application Module] SetUsersInactiveSuccess', props<{ userNames: string[] }>());

export const SetUsersInactiveError = createAction('[Application Module] SetUsersInactiveError', props<{ error: any }>());

export const GetAllTimesheets = createAction('[Application Module] GetAllTimesheets');

export const GetAllTimesheetsSuccess = createAction('[Application Module] GetAllTimesheetsSuccess', props<{ timesheets: Timesheet[] }>());

export const GetAllTimesheetsError = createAction('[Application Module] GetAllTimesheetError', props<{ error: any }>());

export const GetTimekeeperRelatedDelegations = createAction('[Application Module] GetTimekeeperRelatedDelegations');

export const GetUserDelegations = createAction('[Application Module] GetUserDelegation');

export const GetUserDelegationsSuccess = createAction('[Application Module] GetUserDelegationSuccess', props<{ delegations: DelegationEntry[] }>());

export const GetUserDelegationsError = createAction('[Application Module] GetUserDelegationsError', props<{ error: any }>());

export const AddDelegation = createAction('[Application Module] AddUserDelegation', props<{ delegation: DelegationEntry; isTimekeeper: boolean }>());

export const UpdateDelegation = createAction('[Application Module] UpdateUserDelegation', props<{ delegation: DelegationEntry }>());

export const DeleteDelegation = createAction('[Application Module] RemoveUserDelegation', props<{ id: number }>());

export const GetApprovedTimesheets = createAction(
	'[Application Module] GetApprovedTimesheets',
	props<{ allMonthTimesheets?: boolean; isManagerView?: boolean }>()
);

export const GetApprovedTimesheetsSuccess = createAction(
	'[Application Module] GetApprovedTimesheetsSuccess',
	props<{ timesheets: UserTimesheet[]; allTimesheets: UserTimesheet[]; actingAssignments: ScheduledActingAssignment[] }>()
);

export const GetApprovedTimesheetsError = createAction('[Application Module] GetApprovedTimesheetsError', props<{ error: any }>());

export const SaveTimesheet = createAction(
	'[Application Module] SaveTimesheet',
	props<{ startDate: string; timesheet: PostTimesheet; weekRange: string; isManager: boolean }>()
);

export const SubmitTimesheet = createAction(
	'[Application Module] SubmitTimesheet',
	props<{ startDate: string; timesheet: PostTimesheet; weekRange?: string }>()
);

export const PostTimesheetSuccess = createAction('[Application Module] PostTimesheetSuccess', props<{ action: any; response: any }>());

export const PostTimesheetError = createAction('[Application Module] PostTimesheetError', props<{ action: any; error: any }>());

export const SaveTimeEntries = createAction(
	'[Application Module] SaveTimeEntries',
	props<{ yyyyppww: string; timeEntries: TimeEntry[]; weekRange: string }>()
);

export const SubmitTimeEntries = createAction(
	'[Application Module] SubmitTimeEntries',
	props<{ approvedTimesheetsIds: number[]; timeEntries: TimeentryDB[]; allMonthTimesheets: boolean; batchNumber: number; isManagerView: boolean }>()
);

export const GetTimeEntries = createAction('[Application Module] GetTimeEntries');

export const GetTimeEntriesSuccess = createAction('[Application Module] GetTimeEntriesSuccess', props<{ timeEntries: TimeentryDB[] }>());

export const GetTimeEntriesError = createAction('[Application Module] GetTimeEntriesError', props<{ error: any }>());

export const PostTimeEntriesSuccess = createAction('[Application Module] PostTimeEntriesSuccess', props<{ action: any; response: any }>());

export const PostTimeEntriesError = createAction('[Application Module] PostTimeEntriesError', props<{ action: any; error: any }>());

export const CloseTimeEntries = createAction(
	'[Application Module] CloseTimeEntries',
	props<{ allMonthTimesheets: boolean; isManagerView: boolean }>()
);

export const GetEmployeeTimesheets = createAction('[Application Module] GetEmployeeTimesheets');

export const GetEmployeeTimesheetsSuccess = createAction(
	'[Application Module] GetEmployeeTimesheetsSuccess',
	props<{ submissions: ManagerEmployeeTimesheetView[] }>()
);

// export const GetEmployeeTimesheetsError = createAction(
//   '[Application Module] GetEmployeeTimesheetsTeam',
//   props<{ error: any }>()
// );

export const ApproveTimesheets = createAction(
	'[Application Module] ApproveTimesheets',
	props<{ submissions: TimesheetApprovalSubmission[]; weekRange?: string }>()
);

export const UpdateTimesheetApproval = createAction(
	'[Application Module] UpdateTimesheetApproval',
	props<{
		startDate: string;
		timesheet: PostTimesheet;
		weekRange: string;
		approveTimesheetInfo: TimesheetApprovalSubmission[];
		isEdited: boolean;
	}>()
);

export const LoadStaticData = createAction('[Application Module] LoadStaticData');

export const LoadStaticDataSuccess = createAction('[Application Module] LoadStaticDataSuccess', props<{ action: any; response: any }>());

export const LoadStaticDataError = createAction('[Application Module] LoadStaticDataError', props<{ action: any; error: any }>());

export const GetTimeBanks = createAction('[Application Module] GetTimeBanks');

export const GetTimeBanksSuccess = createAction('[Application Module] GetTimeBanksSuccess', props<{ timeBank: TimeBank[] }>());

export const GetTimeBanksError = createAction('[Application Module] GetTimeBanksError', props<{ action: any; error: any }>());

export const ToastUserNotification = createAction('[Application Module] ToastUserNotification', props<{ notification: UserNotification }>());

export const GetNotifications = createAction('[Application Module] GetNotifications');

export const GetNotificationsSuccess = createAction('[Application Module] GetNotificationsSuccess', props<{ notifications: EmailNotification[] }>());

export const GetNotificationsError = createAction('[Application Module] GetNotificationsError', props<{ action: any; error: any }>());

export const UpdateNotification = createAction('[Application Module] UpdateNotification', props<{ notification: EmailNotification }>());

export const UpdateNotificationError = createAction('[Application Module] UpdateNotificationError', props<{ action: any; error: any }>());

export const UpdateNotificationSuccess = createAction('[Application Module] UpdateNotificationSuccess');

export const UpdateNotificationActive = createAction('[Application Module] UpdateNotificationActive', props<{ notification: EmailNotification }>());

export const GetTeamProfilePicsBulk = createAction('[Application Module] GetTeamProfilePicsBulk', props<{ upns: string[] }>());

export const SetTeamProfileBulk = createAction('[Application Module] SetTeamProfileBulk', props<{ userImages: TeamMemberProfile[] }>());

export const SetApprovedTeamProfile = createAction('[Application Module] SetApprovedTeamProfile', props<{ pic: SafeUrl | null; email: string }>());

export const ClearTeamProfile = createAction('[Application Module] ClearTeamProfile');

export const GetTimesheetHistory = createAction('[Application Module] GetTimesheetHistory', props<{ startDate: string; employeeNumber?: string }>());

export const GetTimesheetHistorySuccess = createAction(
	'[Application Module] GetTimesheetHistorySuccess',
	props<{ success: Timesheet[]; action: Action }>()
);

export const GetTimesheetHistoryError = createAction(
	'[Application Module] GetTimesheetHistoryError',
	props<{ error?: HttpErrorResponse; action: Action }>()
);

export const ClearTimesheetHistory = createAction('[Application Module] ClearTimesheetHistory');

export const AddUserImages = createAction('[Application Module] AddUserImages', props<{ userImages: { [id: string]: SafeUrl } }>());

export const SaveMemberProfile = createAction('[Application Module] SaveMemberProfile', props<{ config: Configuration }>());

export const SaveMemberProfileSuccess = createAction('[Application Module] SaveMemberProfileSuccess', props<{ manage: ManageProfile[] }>());

export const SaveMemberProfileError = createAction('[Application Module] SaveMemberProfileError', props<{ action: any; error: any }>());

export const UpdateMemberProfile = createAction('[Application Module] UpdateMemberProfile', props<{ updateConfig: UpdateMemberConfig }>());

export const UpdateMemberProfileSuccess = createAction('[Application Module] UpdateMemberProfileSuccess', props<{ manage: ManageProfile[] }>());

export const UpdateMemberProfileError = createAction('[Application Module] UpdateMemberProfileError', props<{ action: any; error: any }>());

export const GenerateUserProfile = createAction('[Application Module] GenerateUserProfile');

export const CreateNewUser = createAction('[Application Module] CreateNewUser', props<{ newUserDetails: User }>());

export const UpdateExistingUser = createAction('[Application Module] UpdateExistingUser', props<{ updatedUserDetails: UpdateUserAccount }>());
